import fileDownload from 'js-file-download';

import {ThunkActionType} from 'store/types';
import request, {WISBIT_ORGANIZATION} from 'api/requests/request';

import {
  loadUsersRequest,
  loadUsersFailure,
  loadUsersSuccess,
  addUserRequest,
  addUserFailure,
  addUserSuccess,
  editUserRequest,
  editUserSuccess,
  editUserFailure,
  deleteUserRequest,
  deleteUserSuccess,
  deleteUserFailure,
  downloadResultsRequest,
  downloadResultsFailure,
} from './actions';

import {USER_TYPE} from '../userType';
import {
  convertUserDTOToUser,
  convertUserToUserDTO,
} from 'api/converters/userConverters';
import {UserDTO} from 'api/typesDTO/userDTO';
import {User} from 'api/types/userTypes';

export const CHOOSE_ORGANIZATION_ALL = 'all';

export const loadUsers =
  (userType: string, organization?: string): ThunkActionType =>
  async (dispatch, getState) => {
    dispatch(loadUsersRequest(userType));

    const organizationId: string = organization || CHOOSE_ORGANIZATION_ALL;
    try {
      const {
        app: {user: {role = ''} = {}},
      } = getState();

      let headers = {};
      if (role === USER_TYPE.SUPER_ADMIN.serverAlias) {
        headers = {
          [WISBIT_ORGANIZATION]: '',
        };
      }

      const response: UserDTO[] = await request('/user', {
        headers,
      });

      const users = response.map(userDTO => convertUserDTOToUser(userDTO));

      const items = users.reduce(
        (acc: User[], {email, id, name, role, organization}: User) => {
          if (
            role === userType &&
            (organization?.id === organizationId ||
              organizationId === CHOOSE_ORGANIZATION_ALL)
          ) {
            acc.push({
              email,
              id,
              name,
              role,
              organization,
            });
          }
          return acc;
        },
        []
      );

      dispatch(loadUsersSuccess(items));
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(loadUsersFailure(error));
    }
  };

export const addUser =
  (newUser: User, organizationId?: string): ThunkActionType =>
  async dispatch => {
    dispatch(addUserRequest());

    try {
      let headers = {};
      if (organizationId) {
        headers = {
          [WISBIT_ORGANIZATION]: organizationId,
        };
      }

      const newUserData = convertUserToUserDTO(newUser);

      const response = await request('/user', {
        method: 'POST',
        data: newUserData,
        headers,
      });

      dispatch(
        addUserSuccess({
          ...response,
        })
      );
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(addUserFailure(error));
    }
  };

export const editUser =
  (currentUser: User, organizationId?: string): ThunkActionType =>
  async dispatch => {
    dispatch(editUserRequest());

    try {
      let headers = {};
      if (organizationId) {
        headers = {
          [WISBIT_ORGANIZATION]: organizationId,
        };
      }

      await request(`/user/${currentUser.id}`, {
        method: 'PATCH',
        data: convertUserToUserDTO(currentUser),
        headers,
      });

      dispatch(editUserSuccess(currentUser));
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(editUserFailure(error));
    }
  };

export const deleteUser =
  (currentUser: User, organizationId?: string): ThunkActionType =>
  async dispatch => {
    dispatch(deleteUserRequest());

    try {
      let headers = {};
      if (organizationId) {
        headers = {
          [WISBIT_ORGANIZATION]: organizationId,
        };
      }

      await request(`/user/${currentUser.id}`, {
        method: 'DELETE',
        headers,
      });

      dispatch(deleteUserSuccess({...currentUser}));
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(deleteUserFailure(error));
    }
  };

export const downloadResult =
  (userType?: string): ThunkActionType =>
  async dispatch => {
    dispatch(downloadResultsRequest());

    const url = `/statistics/${
      userType === USER_TYPE.CONTENT_CREATOR.id ? 'lesson' : 'student'
    }`;

    const fileName = `${
      userType === USER_TYPE.CONTENT_CREATOR.id
        ? USER_TYPE.CONTENT_CREATOR.text
        : USER_TYPE.LEARNER.text
    }.csv`;

    try {
      const response = await request(url, {
        responseType: 'blob',
      });

      fileDownload(response, fileName);
      /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    } catch (error: any) {
      dispatch(downloadResultsFailure(error));
    }
  };
